import { AlertType } from "../../enums/AlertType";
import { Alert } from "../../interfaces/Alert";
export const ALERT_MESSAGE_SENT_SUCCESS: Alert = {
  type: AlertType.Success,
  title: {
    message: 'Success',
    translated: false,
  },
  message: {
    message: 'custom.message_sent',
    translated: true,
  },
};
